/**
 * Service: glcodesApi
 */
angular.module('acme.common.service.glcodesApi', [
  'acme.common.factory.QueryStringBuilder'
])
.service('GlcodesApiService', ['$http', 'QueryStringBuilderFactory', function($http, QueryStringBuilderFactory) {

    return {

      service: '',

      init: function(endpoint) {
        this.service = endpoint + '/glcode';
        return this;
      },

      list: function(props) {
        var q = '';

        if (props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'get',
          url: this.service.replace(/v1/, 'v2') +'/files/metadata' + q
        });
      }

    };

}]);